import { CLIENT_LEDGER_ENTRY_TYPES } from "../manage/clientLedgerTypes";

function padDatePart(value) {
  return String(value).padStart(2, "0");
}

function monthStartDate(month) {
  return `${month}-01`;
}

function monthEndDate(month) {
  const [year, monthNumber] = month.split("-").map(Number);
  const lastDay = new Date(year, monthNumber, 0).getDate();
  return `${month}-${String(lastDay).padStart(2, "0")}`;
}

export function isDateInMonth(date, month) {
  return date >= monthStartDate(month) && date <= monthEndDate(month);
}

export function getMonthlyClientPayments(entries, clientId, month) {
  return entries
    .filter(entry => entry.clientId === clientId)
    .filter(entry => entry.type === CLIENT_LEDGER_ENTRY_TYPES.PAYMENT)
    .filter(entry => isDateInMonth(entry.date, month))
    .sort((left, right) => {
      const dateDiff = left.date.localeCompare(right.date);
      if (dateDiff !== 0) return dateDiff;
      return (left.entryKey || "").localeCompare(right.entryKey || "");
    });
}

export function formatLocalDate(date = new Date()) {
  return `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(date.getDate())}`;
}

export function buildDefaultPaymentDate(month, today = formatLocalDate()) {
  return isDateInMonth(today, month) ? today : monthEndDate(month);
}
